import { Effects, FormulaFields } from 'services/store/remixer/types';

export default {
  studio: 'Studio',
  header: {
    exportTrack: 'Export Track',
    save: 'Save',
    lastSaved: 'Last saved',
    never: 'Never',
  },
  info: 'info',
  playback: 'playback',
  formulaFieldLabels: {
    [FormulaFields.Genre]: 'Genre Remix',
    [FormulaFields.Energy]: 'Energy',
    [FormulaFields.Duration]: 'Duration',
    [FormulaFields.Bpm]: 'Tempo',
  },
  effects: {
    [Effects.radio]: 'Radio',
    [Effects.destroyer]: 'Destroy',
    [Effects.heavenLow]: 'Heaven Low',
    [Effects.spaciousness]: 'Space',
    [Effects.master]: 'Master Punch',
  },
  formulaDialogAction: {
    cancel: 'Cancel',
    apply: 'Apply',
  },
  errorDialog: {
    title: 'Well this is embarrassing!',
    description: "For some reason, we couldn't render your change.",
    actions: {
      goBack: 'Go Back',
      retry: 'Retry',
    },
  },
  downloadLimitWarning: {
    title: 'Upgrade to Unlock Studio Downloads',
    description: 'To access this feature upgrade your account now.',
    upgrade: 'UPGRADE',
    goBack: 'Maybe Later',
  },
  exportLimit: {
    title: 'Studio export limit reached.',
    descriptionPersonal:
      "You've reached your 30-day limit for Studio exports. Enhance your experience by upgrading now to unlock more.",
    descriptionPro:
      'You have reached your 30-day limit. Come back in {{daysToReset}} days to export more tracks.',
    ctaPersonal: 'Upgrade',
    ctaPro: 'Ok, got it',
    goBack: 'Maybe later',
  },
  undo: 'Undo',
  redo: 'Redo',
  snackbarMessages: {
    saveProjectSuccess: 'Project saved',
    saveProjectError: 'Could not save the project',
    exportTrackError: 'Could not render track',
  },
  exportingModal: {
    rendering: {
      title: 'Rendering track',
      subtitle: 'This will only take a few minutes...',
    },
    renderingComplete: {
      title: 'Rendering complete',
      subtitle: 'Your track can now be listened to, distributed and shared',
      viewInLibrary: 'View in Library',
    },
  },
  userLoop: {
    uploadAudioClip: 'Upload Audio Clip',
    clipRemoved: 'Audio clip removed',
    selectorDialog: {
      title: 'Your Audio',
      cta: 'Apply',
      cancel: 'Cancel',
      unknownError:
        'An unknown error occured while adding your audio sample. Please contact our support for further help.',
    },
    deleteDialog: {
      title: 'Delete audio clip',
      description:
        'By deleting your audio clip, your track will be re-rendered to not include your audio. Are you sure?',
      deleteButtonLabel: 'Yes, Delete',
    },
  },
};
